import { isValidLicensePlate } from '@brazilian-utils/brazilian-utils';
import BotExplanation from '@components/molecules/BotExplanation';
import {
  GetVehiclesByPlateDocument,
  GetVehiclesByPlateQuery,
} from '@graphql/generated';
import createUrqlClient from '@graphql/urqlClient';
import {
  LicencePlateFormResult,
  QuoteInitialForm,
} from '@lib/data/typesQuestions';
import FormField from 'components/atoms/FormField';
import GridBox from 'components/atoms/GridBox';
import TextField from 'components/atoms/TextField';
import OnboardingButtonBar from 'components/molecules/button-bar/OnboardingButtonBar';
import { FC, useState } from 'react';
import { useForm } from 'react-hook-form';
import styled from 'styled-components';

const Form = styled.form``;

interface Props {
  onSubmit: (data: LicencePlateFormResult) => void;
  loading: boolean;
  item: QuoteInitialForm;
  hideBotExplanation?: boolean;
}

const LicencePlateForm: FC<Props> = ({
  onSubmit,
  loading,
  item,
  hideBotExplanation,
}) => {
  const { register, handleSubmit, errors, setValue } = useForm<{
    licencePlate: string;
  }>();
  const [fetching, setFetching] = useState(false);

  const client = createUrqlClient();

  return (
    <Form
      onSubmit={handleSubmit(({ licencePlate }) => {
        setFetching(true);
        client
          .query<GetVehiclesByPlateQuery>(GetVehiclesByPlateDocument, {
            plate: licencePlate,
          })
          .toPromise()
          .then(({ data }) => {
            if (data?.vehiclesByPlate)
              onSubmit({
                vehicleVersions: data.vehiclesByPlate,
                plate: licencePlate,
              });
          })
          .finally(() => {
            setFetching(false);
          });
      })}
    >
      <GridBox justifyContent="center">
        <GridBox width={[1, 0.5, 0.5]}>
          <FormField style={{ width: '100%' }}>
            <TextField
              placeholder="Placa"
              name="licencePlate"
              mask={[
                /[A-Za-z]/,
                /[A-Za-z]/,
                /[A-Za-z]/,
                '-',
                /\d/,
                /[A-Za-z0-9]/,
                /\d/,
                /\d/,
              ]}
              defaultValue={item.vehicle?.plate || ''}
              errorMessage={errors.licencePlate?.message}
              inputRef={register({
                required: 'Precisamos da placa',
                validate: {
                  valid: (s: string) =>
                    isValidLicensePlate(s.replace('-', '')) ||
                    'Precisamos de uma placa válida',
                },
              })}
              onChange={(e) => {
                setValue('licencePlate', e.target.value.toUpperCase());
              }}
            />
          </FormField>
        </GridBox>
      </GridBox>

      {!hideBotExplanation && (
        <BotExplanation>
          Com a placa conseguimos reconhecer as características do seu veículo,
          como o ano e modelo. É mais rápido e prático.
        </BotExplanation>
      )}
      <OnboardingButtonBar loading={loading || fetching} />

      {/* <GridBox justifyContent="center">
        <LinkButton
          onClick={() => {
            trackEvent('skipped plate step');
            onSubmit({ vehicleVersions: [] });
          }}
        >
          Quero cotar sem a placa
        </LinkButton>
      </GridBox> */}
    </Form>
  );
};

export default LicencePlateForm;
